import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Sensible defaults mirror the real print-shop-125 policy so the UI is correct
// even before the live fetch resolves.
export const DEFAULT_FEES = {
  transaction_rate: 0.05,
  processing_rate: 0.025,
  processing_fixed: 0.2,
  listing_fee: 0,
  promotion_waives: "transaction_fee_only",
  connected: false,
  source: "default",
};

export const useFees = () => {
  const [fees, setFees] = useState(DEFAULT_FEES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/fees`)
      .then((res) => {
        if (active && res.data) setFees({ ...DEFAULT_FEES, ...res.data });
      })
      .catch(() => {})
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return { fees, loading };
};

// Format a rate like 0.05 -> "5%" (drops trailing .0)
export const pct = (rate) => {
  const v = (rate || 0) * 100;
  return `${Number.isInteger(v) ? v : v.toFixed(1)}%`;
};

export const money = (n) =>
  `$${(Math.round((Number(n) || 0) * 100 + 1e-6) / 100).toFixed(2)}`;
